import '../App.css'
import React, { useState, useEffect, useRef } from "react";
import Slider from 'react-input-slider';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';

import xbot from '../Models/xbot/xbot.glb';
import ybot from '../Models/ybot/ybot.glb';
import xbotPic from '../Models/xbot/xbot.png';
import ybotPic from '../Models/ybot/ybot.png';

import * as words from '../Animations/words';
import * as alphabets from '../Animations/alphabets';
import { defaultPose } from '../Animations/defaultPose';

import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

function LearnSign() {
  const [bot, setBot] = useState(ybot);
  const [speed, setSpeed] = useState(0.1);
  const [pause, setPause] = useState(800);

  const componentRef = useRef({});
  const { current: ref } = componentRef;

  useEffect(() => {

    ref.flag = false;
    ref.pending = false;

    ref.animations = [];
    ref.characters = [];

    ref.scene = new THREE.Scene();
    ref.scene.background = new THREE.Color(0xdddddd);

    const spotLight = new THREE.SpotLight(0xffffff, 2);
    spotLight.position.set(0, 5, 5);
    ref.scene.add(spotLight);

    ref.camera = new THREE.PerspectiveCamera(
        30,
        window.innerWidth * 0.46 / (window.innerHeight - 70),
        0.1,
        1000
    )

    ref.renderer = new THREE.WebGLRenderer({ antialias: true });
    ref.renderer.setSize(window.innerWidth * 0.46, (window.innerHeight - 70));
    document.getElementById("canvas").innerHTML = "";
    document.getElementById("canvas").appendChild(ref.renderer.domElement);

    ref.camera.position.z = 1.6;
    ref.camera.position.y = 1.4;
    ref.camera.position.x = 0;
    ref.camera.lookAt(0, 1.4, 0);

    let loader = new GLTFLoader();
    loader.load(
      bot,
      (gltf) => {
        gltf.scene.traverse((child) => {
          if ( child.type === 'SkinnedMesh' ) {
            child.frustumCulled = false;
          }
    });
        ref.avatar = gltf.scene;
        ref.scene.add(ref.avatar);
        defaultPose(ref);
      },
      (xhr) => {
        console.log(xhr);
      }
    );

  }, [ref, bot]);

  ref.animate = () => {
    if(ref.animations.length === 0){
        ref.pending = false;
      return ;
    }
    requestAnimationFrame(ref.animate);
    if(ref.animations[0].length){
        if(!ref.flag) {
          for(let i=0;i<ref.animations[0].length;){
            let [boneName, action, axis, limit, sign] = ref.animations[0][i]
            if(sign === "+" && ref.avatar.getObjectByName(boneName)[action][axis] < limit){
                ref.avatar.getObjectByName(boneName)[action][axis] += speed;
                ref.avatar.getObjectByName(boneName)[action][axis] = Math.min(ref.avatar.getObjectByName(boneName)[action][axis], limit);
                i++;
            }
            else if(sign === "-" && ref.avatar.getObjectByName(boneName)[action][axis] > limit){
                ref.avatar.getObjectByName(boneName)[action][axis] -= speed;
                ref.avatar.getObjectByName(boneName)[action][axis] = Math.max(ref.avatar.getObjectByName(boneName)[action][axis], limit);
                i++;
            }
            else{
                ref.animations[0].splice(i, 1);
            }
          }
        }
    }
    else {
      ref.flag = true;
      setTimeout(() => {
        ref.flag = false
      }, pause);
      ref.animations.shift();
    }
    ref.renderer.render(ref.scene, ref.camera);
  }

  let alphaButtons = [];
  for (let i = 0; i < 26; i++) {
    alphaButtons.push(
        <div className='col-md-3'>
            <button className='signs w-100' onClick={()=>{
              if(ref.animations.length === 0){
                alphabets[String.fromCharCode(i + 65)](ref);
              }
            }}>
                {String.fromCharCode(i + 65)}
            </button>
        </div>
    );
  }

  let wordButtons = [];
  for (let i = 0; i < words.wordList.length; i++) {
    wordButtons.push(
        <div className='col-md-4'>
            <button className='signs w-100' onClick={()=>{
              if(ref.animations.length === 0){
                words[words.wordList[i]](ref);
              }
            }}>
                {words.wordList[i]}
            </button>
        </div>
    );
  }

  return (
    <div className='container-fluid' style={{padding: '2rem'}}>
      <div className='row'>
        <div className='col-md-3'>
            <div style={{background: 'white', padding: '20px', borderRadius: '20px', boxShadow: 'var(--shadow-lg)', maxHeight: '80vh', overflowY: 'auto'}}>
              <h4 className="section-title">Alphabets</h4>
              <div className='row no-gutters'>
                  {
                      alphaButtons.map((btn, idx) => (
                        <div key={idx} className="col-3 p-1">
                          {React.cloneElement(btn.props.children, { className: 'signs w-100', style: {padding: '8px 0', fontSize: '1.1rem'} })}
                        </div>
                      ))
                  }
              </div>
              <h4 className="section-title mt-4">Words</h4>
              <div className='row no-gutters'>
                  {
                      wordButtons.map((btn, idx) => (
                        <div key={idx} className="col-12 p-1">
                          {React.cloneElement(btn.props.children, { className: 'signs w-100', style: {textAlign: 'left', paddingLeft: '20px'} })}
                        </div>
                      ))
                  }
              </div>
            </div>
        </div>
        
        <div className='col-md-6'>
          <div id='canvas' style={{height: '100%', minHeight: '600px'}}/>
        </div>

        <div className='col-md-3'>
          <div style={{background: 'white', padding: '20px', borderRadius: '20px', boxShadow: 'var(--shadow-lg)'}}>
            <h4 className="section-title">Settings</h4>

            <p className='bot-label'>
              Select Avatar
            </p>
            <div className="row">
                <div className="col-6">
                    <img 
                      src={xbotPic} 
                      className={`bot-image w-100`} 
                      onClick={()=>{setBot(xbot)}} 
                      alt='Avatar 1: XBOT'
                      style={{border: bot === xbot ? '3px solid var(--primary-color)' : '3px solid transparent'}}
                    />
                    <p className="text-center small font-weight-bold" style={{color: bot === xbot ? 'var(--primary-color)' : 'inherit'}}>X-BOT</p>
                </div>
                <div className="col-6">
                    <img 
                      src={ybotPic} 
                      className={`bot-image w-100`} 
                      onClick={()=>{setBot(ybot)}} 
                      alt='Avatar 2: YBOT'
                      style={{border: bot === ybot ? '3px solid var(--primary-color)' : '3px solid transparent'}}
                    />
                    <p className="text-center small font-weight-bold" style={{color: bot === ybot ? 'var(--primary-color)' : 'inherit'}}>Y-BOT</p>
                </div>
            </div>

            <hr style={{margin: '20px 0', borderColor: '#eee'}}/>

            <p className='label-style'>
              Animation Speed: <span style={{color: 'var(--primary-color)'}}>{Math.round(speed*100)/100}</span>
            </p>
            <Slider
              axis="x"
              xmin={0.05}
              xmax={0.50}
              xstep={0.01}
              x={speed}
              onChange={({ x }) => setSpeed(x)}
              className='w-100'
              styles={{
                  track: { backgroundColor: '#e0e0e0' },
                  active: { backgroundColor: 'var(--primary-color)' },
                  thumb: { width: 20, height: 20, backgroundColor: 'var(--accent-color)' }
              }}
            />

            <p className='label-style mt-4'>
              Pause time: <span style={{color: 'var(--primary-color)'}}>{pause} ms</span>
            </p>
            <Slider
              axis="x"
              xmin={0}
              xmax={2000}
              xstep={100}
              x={pause}
              onChange={({ x }) => setPause(x)}
              className='w-100'
              styles={{
                  track: { backgroundColor: '#e0e0e0' },
                  active: { backgroundColor: 'var(--primary-color)' },
                  thumb: { width: 20, height: 20, backgroundColor: 'var(--accent-color)' }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LearnSign;
